import script from "./QuizDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizDetailPage.vue?vue&type=style&index=0&id=0e18d4d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e18d4d0"]])

export default __exports__